import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/auth-module/rl-logo.svg'


const _hoisted_1 = { class: "bg-white flex gap-6 h-screen grid grid-cols-1 lg:grid-cols-2" }
const _hoisted_2 = { class: "flex flex-col mt-[6rem] items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "w-12 h-12"
}, null, -1)
const _hoisted_4 = { class: "text-3xl font-semibold mt-5" }
const _hoisted_5 = { class: "font-normal text-base mt-1" }
const _hoisted_6 = {
  key: 0,
  class: "w-[50%] mt-5 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800"
}
const _hoisted_7 = {
  key: 1,
  class: "w-[50%] mt-5 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800"
}
const _hoisted_8 = { class: "w-[50%]" }
const _hoisted_9 = { class: "flex justify-start mt-4 px-1 font-bold" }
const _hoisted_10 = {
  key: 0,
  class: "mt-4 px-1"
}
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "flex justify-center mt-5" }
const _hoisted_15 = { class: "text-sm text-gray-600 font-normal" }
const _hoisted_16 = { class: "flex justify-center mt-5 border-t border-gray-200 pt-4" }
const _hoisted_17 = { class: "text-sm text-gray-600 font-normal" }
const _hoisted_18 = ["src"]

import router from "@/router";
import { useUserStore } from "@/stores/userStore";
import backgroundSvg from "@/assets/auth-module/right-side-bg.svg";
import { useRoute } from "vue-router";
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { getSelectableRegions } from "@/lib/runtime-url-resolver";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const backgroundImageStyle = `background-image: url('${backgroundSvg}')`;

const userStore = useUserStore();
const route = useRoute();
const { t } = useI18n();

// Login-page region selector (fallback for shared internal admins). Config-driven:
// no configured regions -> the "Advanced" section is not rendered at all.
const selectableRegions = getSelectableRegions();
const hasRegionSelector = selectableRegions.length > 0;
const showAdvanced = ref(false);

// Set by the router when it signs out a session whose home cluster changed.
const regionChanged = computed(() => route.query.regionChanged === "1");
// Set by region-moved.ts when it signs out an admin whose school moved region.
const schoolMoved = computed(() => route.query.schoolMoved === "1");
const regionOptions = computed(() => [
  { label: t("login_view.region_automatic"), value: "" },
  ...selectableRegions.map((r) => ({ label: r.label, value: r.code })),
]);

const forgotPassword = () => {
  router.push("/auth/forgot-password");
};

const GoToComplete = () => {
  router.push("/auth/complete-registration");
};

const handleSubmit = async (value: any) => {
  let response = await userStore.login(value);

  if (!response) {
    alert(userStore.loginError || "Password or username are incorrect...");
  } else {
    // Only navigate if there's an explicit redirect query param.
    // Otherwise fetchSchoolStructureData already navigated to the
    // correct defaultHome during the login flow.
    const redirect = route.query.redirect as string;
    if (redirect) {
      router.push(redirect);
    }
  }
};

const redirectToStudentLogin = () => {
  window.location.href = "https://app.reflectivelearning.co.za";
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("login_view.title")), 1),
      _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("login_view.sub_title")), 1),
      (regionChanged.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("login_view.region_changed_notice")), 1))
        : _createCommentVNode("", true),
      (schoolMoved.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("login_view.school_moved_notice")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_FormKit, {
          type: "form",
          id: "login-form",
          actions: false,
          onSubmit: handleSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              name: "email",
              type: "email",
              label: _ctx.$t('login_view.email_label'),
              validation: "required|email",
              "outer-class": "my-4",
              "input-class": "h-11 mt-1",
              placeholder: _ctx.$t('login_view.email_placeholder'),
              "validation-messages": {
              required: _ctx.$t('login_view.email_required'),
              length: _ctx.$t('login_view.email_length'),
            }
            }, null, 8, ["label", "placeholder", "validation-messages"]),
            _createVNode(_component_FormKit, {
              name: "password",
              label: _ctx.$t('login_view.password_label'),
              type: "password",
              validation: "required|length:6",
              "outer-class": "mt-4",
              "input-class": "h-11 pr-[3%] mt-1",
              placeholder: _ctx.$t('login_view.password_placeholder'),
              "validation-messages": {
              required: _ctx.$t('login_view.password_required'),
              length: _ctx.$t('login_view.password_length'),
            }
            }, null, 8, ["label", "placeholder", "validation-messages"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                class: "font-bold text-sm text-blue-600 cursor-pointer",
                onClick: forgotPassword
              }, _toDisplayString(_ctx.$t("login_view.forgot_password")), 1)
            ]),
            hasRegionSelector
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("a", {
                    class: "font-bold text-sm text-blue-600 cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showAdvanced.value = !showAdvanced.value))
                  }, _toDisplayString(_ctx.$t("login_view.advanced_options")), 1),
                  _withDirectives(_createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_FormKit, {
                      name: "region",
                      type: "select",
                      label: _ctx.$t('login_view.region_label'),
                      options: regionOptions.value,
                      value: '',
                      "outer-class": "my-2",
                      "input-class": "h-11 mt-1"
                    }, null, 8, ["label", "options"])
                  ], 512), [
                    [_vShow, showAdvanced.value]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_FormKit, {
              type: "submit",
              class: "w-full h-11 opacity-50 font-semibold text-base text-white rounded-[20px] mt-6",
              inputClass: "mt-4 px-6 py-[10px]"
            }, {
              default: _withCtx(() => [
                (_unref(userStore).loader.login)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("login_view.btn_sign_in")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("login_view.btn_sign_in")), 1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, [
            _createTextVNode(_toDisplayString(_ctx.$t("login_view.dont_have_account")) + " ", 1),
            _createElementVNode("a", {
              onClick: GoToComplete,
              class: "text-sm cursor-pointer font-semibold text-blue-600"
            }, _toDisplayString(_ctx.$t("login_view.sign_up")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("login_view.student_login")), 1)
        ]),
        _createElementVNode("button", {
          onClick: redirectToStudentLogin,
          class: "formkit-input inline-block w-full rounded-lg bg-blue-600 py-2 px-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-base font-semibold leading-normal text-white mt-4 px-6 py-[10px]",
          type: "button"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("login_view.student_login_btn")), 1)
        ])
      ])
    ]),
    _createElementVNode("section", {
      class: "flex items-end rounded-tl-[80px] rounded-bl-[80px] bg-no-repeat bg-cover bg-center",
      style: backgroundImageStyle
    }, [
      _createElementVNode("img", {
        src: require('@/assets/auth-module/man-image.png'),
        class: "w-full",
        alt: "Man Image"
      }, null, 8, _hoisted_18)
    ])
  ]))
}
}

})